export const USER_CHECKLIST_PAGE_SIZE = '50';
